module.exports = __webpack_public_path__ + "img/photo-0040.99f2dee1.jpg";